// extracted by mini-css-extract-plugin
module.exports = {"bi-chevron-down":"BuyerOrdersPage_bi-chevron-down__28Jb1","root":"BuyerOrdersPage_root__3OZbE","formContainer":"BuyerOrdersPage_formContainer__2SlLt"};